import React, { useEffect, useState } from 'react';
import { getTranslate } from 'react-localize-redux';
import axios from 'axios';

//#region userServices (TEMPORARY)
const isDev = process.env.NODE_ENV !== 'production';

function throwIfServerError(error) {
  let errMsg = 'Unexpected_error_occurred';
  if (error && error.response && error.response.data) {
    if (error.response.data.UserMessage) {
      errMsg = error.response.data.UserMessage;
    }
    // try to recover w developer message
    if (!error.response.data.UserMessage && error.response.data.DeveloperMessage) {
      errMsg = error.response.data.DeveloperMessage;
    }
    if (isDev && error.response.data.DeveloperMessage !== errMsg) {
      errMsg = `${errMsg} (${error.response.data.DeveloperMessage})`;
    }
  }

  throw new Error(errMsg);
}
interface RequestSmsCodeCallParams {
  PhoneNumber: string;
  Fallback: string;
}
async function requestSmsCodeCall(params: RequestSmsCodeCallParams) {
  try {
    await axios.post('/Account/RequestPhoneLoginCodeSms/', params);
  } catch (error) {
    throwIfServerError(error);
  }
}
//#endregion

//#region useCountdown HOOOOOOK
function useCountdown(countdownSec = 30) {
  const [countdown, setCountdown] = useState(countdownSec);
  const [countdownCount, setCountdownCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((current) => {
        if (current <= 0) {
          clearInterval(interval);

          return 0;
        }

        return current - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [countdownCount]);

  const startAgain = () => {
    if (countdown <= 0) {
      setCountdown(countdownSec);
      setCountdownCount((current) => current + 1);
    }
  };

  return [countdown, startAgain, countdownCount] as [number, () => void, number];
}
//#endregion

type Props = {
  translate: ReturnType<typeof getTranslate>;
  PhoneNumber: string;
  children: (props: {
    button: {
      children: React.ReactNode;
      disabled: boolean;
      onClick(): void;
    };
  }) => JSX.Element;

  onSubmit?(): void;
  onSuccess?(): void;
  onError?(error: Error): void;
};

const PhoneCallButton = (props: Props) => {
  const { translate, PhoneNumber, children, onSubmit, onSuccess, onError } = props;

  const [submitting, setSubmitting] = useState<boolean>(false);
  const [callRequested, setCallRequested] = useState<boolean>(false);
  const [countdown, startCountdownAgain, countdownCount] = useCountdown(30);

  const handleRequestPhoneCall = async () => {
    try {
      // maybe we should do something like this...
      // if (countdownCount > 10) {
      //   throw new Error('sorry but no hpe 4 u, pls contact our support team');
      // }
      setSubmitting(true);
      setCallRequested(true);

      if (onSubmit) {
        onSubmit();
      }

      await requestSmsCodeCall({
        PhoneNumber,
        Fallback: 'PhoneCall'
      });

      startCountdownAgain();

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const renderRequestPhoneCallBtnTxt = () => {
    if (countdown > 0) {
      return `${translate(
        callRequested ? 'Call_requested_request_again' : 'Request_code_via_phone_call'
      )} ${countdown}s`;
    } else {
      return `${translate('Request_code_via_phone_call')}`;
    }
  };
  const text = renderRequestPhoneCallBtnTxt();
  return children({
    button: {
      disabled: countdown > 0 || submitting,
      onClick: handleRequestPhoneCall,
      children: text
    }
  });
};

export default PhoneCallButton;
